import React, { useEffect } from "react";
import { useField } from "formik";
import { Autocomplete, InputLabel, TextField } from "@mui/material";

const SearchableSelect = (props) => {
  const { label, options, onChange, isHidden,value, isDisabled = false, ...rest } = props;
  const [field, meta, helpers] = useField(props);

  useEffect(() => {
    if (options && options?.length > 0 && !isHidden) {
      helpers.setValue(value || options[0]);
    }
  }, [options?.length, helpers]);

  const handleChange = (event, value) => {
    helpers.setValue(value ? value : {});
    if(onChange){
      onChange(value)
    }
  };

  return (
    <>
      <InputLabel htmlFor={field.name} sx={{ height: "14px", marginBottom: "0" }}>
        {label}
      </InputLabel>
      <Autocomplete
        options={options || []}
        getOptionLabel={(option) => option.name || option.title || option.codeName || ''}
        onChange={handleChange}
        isOptionEqualToValue={(option, value) => option.id === value?.id}
        value= {field.value || null}
        disabled={isDisabled}
        getOptionKey={(option) => option.id || option.name || option.title}
        renderInput={(params) => (
          <TextField
            sx={{
              '& .MuiInputBase-root': {
                height: 'auto',
              }
            }}
            {...params}
            {...rest}
            variant="standard"
            fullWidth
            error={meta.touched && Boolean(meta.error)}
            helperText={meta.touched && meta.error ? meta.error : ""}
          />
        )}
      />
    </>
  );
};

export default React.memo(SearchableSelect);
